import SimpleObservable from "../../helper/simple-observable";
import { InventoryZone } from "./inventory-zone";

/**
 * Global emitter for inventory zone updates.
 * When changes are made to a zone (e.g., in the settings modal),
 * emit the updated zone through this observable so all subscribers
 * can react to the changes.
 */
export const INVENTORY_ZONE_UPDATE_OBSERVABLE =
	new SimpleObservable<InventoryZone>();
